import styled from "styled-components/macro";

export default styled.div`
 .rte{
    min-height:410px;
 }
`;
